import React from 'react';
import {
    Cell,
    Grid,
    H2,
} from '@saladbob/sassafras'

import Game from './Game';
import ByGame from './ByGame';

import style from './bracket.module.css';

import { Game as GameType } from '../../types'

type Props = {
    games: GameType[],
    tbGames: GameType[],
};

const rows = 29;

const Bracket8: React.FC<Props> = ({games, tbGames}) => {
    return (
        <div style={{ height: '100%', minWidth: 1124 }}>
            <Grid columns="repeat(6, 1fr)">
                {/* Round 1 */}
                <Grid rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '1 / 3' }}>
                        <Game game={games[0]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '5 / 7' }}>
                        <Game game={games[1]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '9 / 11' }}>
                        <Game game={games[2]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '13 / 15' }}>
                        <Game game={games[3]} topLabel bottomLabel />
                    </Cell>

                    {/* Toilet Bowl Heading */}

                    <Cell style={{ gridRow: '17 / 19' }} align="center" justify="flex-end" pe="md">
                        <H2 font="leader" className={style.bracketHeading} color="primary">TOILET BOWL BRACKET</H2>
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '19 / 21' }} ps="md">
                        <H2 font="leader" className={style.bracketHeading} color="primary">LOSERS BRACKET</H2>
                    </Cell>
                    <Cell style={{ gridRow: '21 / 23' }}>
                        <Game game={games[4]} topLabel bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '25 / 27' }}>
                        <Game game={games[5]} topLabel bottomLabel />
                    </Cell>
                </Grid>
                {/* Round 2 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    
                    <Cell style={{ gridRow: '2 / 6' }}>
                        <Game game={games[6]} />
                    </Cell>
                    <Cell style={{ gridRow: '10 / 14' }}>
                        <Game game={games[7]} />
                    </Cell>

                    {/* Toilet Bowl */}

                    <Cell style={{ gridRow: '17 / 19' }} bgColor="tertiary200">
                        <Game game={tbGames[0]} bottomLabel topLabel />
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '22 / 24' }}>
                        <Game game={games[8]} bottomLabel />
                    </Cell>
                    <Cell style={{ gridRow: '26 / 28' }}>
                        <Game game={games[9]} bottomLabel />
                    </Cell>
                </Grid>
                {/* Round 3 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '4 / 12' }}>
                        <Game game={games[10]} />
                    </Cell>

                    {/* Toilet Bowl */}

                    <Cell style={{ gridRow: '17 / 18' }} bgColor="tertiary200" />
                    <Cell style={{ gridRow: '18 / 19' }} bgColor="tertiary200">
                        <ByGame tb color="black" />
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '23 / 27' }}>
                        <Game game={games[11]} />
                    </Cell>
                </Grid>
                {/* Round 4 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>
                    <Cell style={{ gridRow: '8 / 10' }}>
                        <ByGame />
                    </Cell>

                    {/* Losers */}

                    <Cell style={{ gridRow: '25 / 29' }}>
                        <Game
                            game={games[12]}
                            bottomLabel
                            trophy='trophy'
                            trophyColor={['#A05822', 'white']}
                        />
                    </Cell>
                </Grid>

                {/* Round 5 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`}>

                    <Cell style={{ gridRow: '8 / 27' }}>
                        <Game game={games[13]} />
                    </Cell>
                </Grid>
                {/* Round 6 */}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.printOnly}`}>
                    <Cell style={{ gridRow: '18 / 20' }} width="100px">
                        <ByGame loserTrophy trophy />
                    </Cell>

                    <Cell style={{ gridRow: '20 / 22' }}>
                        <Game game={games[14]} />
                    </Cell>
                </Grid>

                {games[13].winner && games[13].team2.id === games[13].winner.id && (
                    <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.screenOnly}`}>
                        <Cell style={{ gridRow: '16 / 19' }} width="260px">
                            <Game game={games[14]} />
                        </Cell>
                    </Grid>
                )}
                <Grid columns="1fr" rows={`repeat(${rows}, 1fr)`} className={`${style.championship} ${style.screenOnly}`}>
                    <Cell style={{ gridRow: '18 / 20' }} width="100px">
                        <ByGame trophy loserTrophy />
                    </Cell>
                </Grid>
            </Grid>
        </div>
    );
}

export default Bracket8;
